<template>
  <div class="section" id="myPage">
    <div class="columns">
      <div class="column is-8-desktop is-offset-2-desktop">
        <h1 class="subtitle">マイページ</h1>

        <div class="sectionwrap">
          <div class="columns is-align-items-center">
            <div class="column">
              <h2 class="heading">ユーザープロフィール</h2>
              <p class="text">
                ここで今のプロフイールを表示ここで今のプロフイールを表示<br />ここで今のプロフィールを表示
              </p>
            </div>
            <div class="column is-one-third-desktop">
              <router-link to="/profile">
                <b-button class="button is-primary is-fullwidth">
                  プロフィールを確認
                </b-button>
              </router-link>
            </div>
          </div>
        </div>

        <div class="sectionwrap">
          <div class="columns is-align-items-center">
            <div class="column">
              <h2 class="heading">お気に入りのパフォーマー</h2>
            </div>
            <div class="column is-one-third-desktop">
              <router-link to="/mypage/liked-performer">
                <b-button class="button is-primary is-fullwidth">
                  お気に入りのパフォーマー確認
                </b-button>
              </router-link>
            </div>
          </div>
        </div>

        <div class="sectionwrap">
          <div class="columns is-align-items-center">
            <div class="column">
              <h2 class="heading">支払い情報管理</h2>
            </div>
            <div class="column is-one-third-desktop">
              <router-link to="/payment">
                <b-button class="button is-primary is-fullwidth">
                  支払い情報確認/編集
                </b-button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyPage'
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/mypage.scss';
</style>
